"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconGeolocation = void 0;
var React = __importStar(require("react"));
var IconGeolocation = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#0079FF", fillRule: "evenodd", d: "M14.4678,15.5672 L12.9808,10.3622 C12.9338,10.1962 12.8038,10.0662 12.6378,10.0192 L7.4328,8.5322 L16.8128,6.1872 L14.4678,15.5672 Z M17.8538,5.1462 C17.7298,5.0232 17.5498,4.9722 17.3788,5.0142 L5.3788,8.0142 C5.1588,8.0692 5.0038,8.2652 4.9998,8.4912 C4.9958,8.7172 5.1458,8.9192 5.3628,8.9802 L12.0958,10.9042 L14.0198,17.6372 C14.0808,17.8522 14.2778,18.0002 14.4998,18.0002 L14.5088,18.0002 C14.7348,17.9962 14.9308,17.8402 14.9858,17.6212 L17.9858,5.6212 C18.0278,5.4512 17.9778,5.2702 17.8538,5.1462 L17.8538,5.1462 Z" }))); };
exports.IconGeolocation = IconGeolocation;
exports.IconGeolocation.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconGeolocation;
